<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Edit Punch dates</p>
        </header>
        <section class="modal-card-body" >
            <o-field label="Clock in">
                <datepicker v-model="clock_in" :absolute="true" :enable-time="true" v-bind:class="{ 'is-danger': !clock_in }" />
            </o-field>
            <o-field label="Clock out">
                <datepicker v-model="clock_out" :absolute="true" :enable-time="true" v-bind:class="{ 'is-danger': !clock_out }" />
            </o-field>
        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
            <button @click.prevent="handleSubmit" v-submit="submitting" class="button is-primary">Save</button>
        </footer>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Datepicker from './../../components/Datepicker'
    import HandlesForm from './../../mixins/HandlesForm'

    export default {
        props: ['clocklog'],

        mixins: [HandlesForm],

        components: {
            Datepicker,
        },

        computed: {
            ...mapGetters([]),
        },
        
        data() {
            return {
                clock_in: null,
                clock_out: null,
                date: null,
            }
        },

        mounted() {
            this.initialize()
        },

        methods: {
            ...mapActions(['updateClocklog']),

            handleSubmit() {
                let submit = this.wrapSubmit(this.updateClocklog)
                const { clock_in, clock_out } = this
                submit({
                    ...this.clocklog,
                    clock_in,
                    clock_out,
                }).then(r => {
                    this.$parent.$parent.$emit('update:active', false)
                    this.$emit('onSaved')
                    return r
                })
            },
            initialize() {
                const { clock_in, clock_out, date } = this.clocklog || {}
                this.clock_in = clock_in || date
                this.clock_out = clock_out || date
                this.date = date
            },
        }
    }
</script>